import MasterDiscussionModel from '../Apis/MasterDiscussion.js'
import Controller from './Controller.js';

export default class MasterDiscussionController extends Controller {

    constructor() {
        super(new MasterDiscussionModel());
    }


}